import { notifyAccessDenied, notifyPolicyEpoch } from "@/security/access/events";

// Get backend URL from environment variable
const BACKEND_URI = import.meta.env.VITE_API_BASE_URL || "";

const fetchWithAuth = async (input: RequestInfo, token: string, init?: RequestInit) => {
    const headers: HeadersInit = {
        ...(init?.headers || {}),
        ...(token
            ? {
                  Authorization: `Bearer ${token}`
              }
            : {})
    };

    // Only set Content-Type if not already set, if there's a body, and if body is NOT FormData
    // FormData requires the browser to set Content-Type automatically with the multipart boundary
    if (init?.body && !(headers as any)['Content-Type'] && !(init.body instanceof FormData)) {
        (headers as any)['Content-Type'] = 'application/json';
    }

    const newInit: RequestInit = {
        ...init,
        headers
    };

    // Prepend BACKEND_URI if the input is a relative URL (starts with /)
    let url = input;
    if (typeof input === 'string' && input.startsWith('/')) {
        url = `${BACKEND_URI}${input}`;
    }

    const response = await fetch(url, newInit);
    const isAccessRefresh = typeof url === "string" && url.includes("/api/access/session");
    if (response.status === 403 && !isAccessRefresh) notifyAccessDenied();
    const policyEpoch = response.headers.get("X-Policy-Epoch");
    if (policyEpoch) notifyPolicyEpoch(policyEpoch);
    return response;
};

export default fetchWithAuth;
